const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

export const BaseConfig = {
  baseApiUrl,
};
